import { useNavigate, useParams } from 'react-router-dom';
import BottomSheet from '../base/BottomSheet';

interface ClientMoreSheetProps {
  open: boolean;
  onClose: () => void;
  handleExit: () => void;
}

export default function ClientMoreSheet({ open, onClose, handleExit }: ClientMoreSheetProps) {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  const handleNavigate = (to: string) => {
    onClose();
    navigate(to);
  };

  const handleExitAndClose = () => {
    onClose();
    handleExit();
  };

  const items = [
    { to: `/client/${token}/sessions`, label: 'Mis Sesiones', icon: 'ri-camera-line', color: 'text-teal-600' },
    { to: `/client/${token}/dvd`, label: 'DVD Online', icon: 'ri-disc-line', color: 'text-rose-600' },
    { to: `/client/${token}/descargas`, label: 'Descargas', icon: 'ri-download-cloud-line', color: 'text-purple-600' },
    { to: `/client/${token}/invitation`, label: 'Invitaciones', icon: 'ri-mail-send-line', color: 'text-rose-600' },
    { to: `/client/${token}/print-approvals`, label: 'Print Approvals', icon: 'ri-check-double-line', color: 'text-teal-600' },
    { to: `/client/${token}/pose-guides`, label: 'Guías', icon: 'ri-book-open-line', color: 'text-teal-600' },
    { to: `/client/${token}/photobooks`, label: 'Photobooks', icon: 'ri-book-2-line', color: 'text-teal-600' },
    {
      external: true,
      href: 'https://wa.me/17078066168',
      label: 'Contacto',
      icon: 'ri-whatsapp-line',
      color: 'text-green-600',
    },
  ];

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title="Más opciones"
      maxHeight="75vh"
    >
      {/* Grid de items */}
      <div className="px-3 sm:px-4 py-3 grid grid-cols-2 sm:grid-cols-3 gap-1.5 sm:gap-2">
        {items.map((item) =>
          item.external ? (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClose}
              className="flex flex-col items-center justify-center gap-1 p-2 sm:p-3 min-h-[64px] sm:min-h-[72px] bg-gray-50 hover:bg-gray-100 active:bg-gray-200 rounded-xl transition-colors cursor-pointer"
            >
              <div className={`w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-lg sm:text-xl`}></i>
              </div>
              <span className="text-[10px] sm:text-xs font-medium text-gray-700 text-center leading-tight">
                {item.label}
              </span>
            </a>
          ) : (
            <button
              key={item.label}
              onClick={() => handleNavigate(item.to!)}
              className="flex flex-col items-center justify-center gap-1.5 p-2 sm:p-3 min-h-[64px] sm:min-h-[72px] bg-gray-50 hover:bg-teal-50 active:bg-teal-100 rounded-xl transition-colors cursor-pointer"
            >
              <div className={`w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-lg sm:text-xl`}></i>
              </div>
              <span className="text-[10px] sm:text-xs font-medium text-gray-700 text-center leading-tight">
                {item.label}
              </span>
            </button>
          )
        )}
      </div>

      {/* Footer / Salir */}
      <div className="px-3 sm:px-4 py-3 border-t border-gray-100">
        <button
          onClick={handleExitAndClose}
          className="flex items-center gap-3 w-full px-3 sm:px-4 py-3 min-h-[52px] text-red-600 hover:bg-red-50 rounded-xl transition-colors cursor-pointer"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-red-50 rounded-xl">
            <i className="ri-logout-box-line text-lg"></i>
          </div>
          <span className="text-sm font-semibold">Salir del Portal</span>
        </button>
      </div>
    </BottomSheet>
  );
}